import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=91446a1c&scoped=true"
import script from "./client-list.vue?vue&type=script&lang=js"
export * from "./client-list.vue?vue&type=script&lang=js"
import style0 from "./client-list.vue?vue&type=style&index=0&id=91446a1c&scoped=true&lang=css"
import style1 from "./client-list.vue?vue&type=style&index=1&id=91446a1c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91446a1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91446a1c')) {
      api.createRecord('91446a1c', component.options)
    } else {
      api.reload('91446a1c', component.options)
    }
    module.hot.accept("./client-list.vue?vue&type=template&id=91446a1c&scoped=true", function () {
      api.rerender('91446a1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/client-list.vue"
export default component.exports